import { generateBridge } from '../Utility/GenerateBridge';

export type TrackingBridgeSync = {
    logError: (payload: ErrorMessage) => void;
    logMessage: (payload: String) => void;
    logEvent: (payload: NativeTrackingEvent) => void;
    logPurchase: (payload: NativePurchaseTrackingEvent) => void;
    setTrackingEnabled: (enabled: boolean) => void;
    clearPersistedTrackingData: () => void;
    getPersistedTrackingData: () => { [key: string]: NativeTrackingEvent };
    getAttribution: ()=> AdjustAttributionData;
};
export type NativeTrackingEvent = {
    event: string;
    token?: string;
    value?: string | number;
    parameters?: { [key: string]: string | number };
};

export type NativePurchaseTrackingEvent = {
    token: string;
    sku: string;
    price: string;
    currency: string;
    orderId: string;
};

export type ErrorMessage = {
    message: string;
    url: string;
    line: number;
    column: number;
    error: string;
};

export type AdjustAttributionData = {
    trackerToken: string;
    trackerName: string;
    network: string;
    campaign: string;
    adgroup: string;
    creative: string;
    clickLabel: string;
    adid: string;
};

export const Tracking = generateBridge({
    name: 'Tracking',
    sync: {
        clearPersistedTrackingData: undefined,
        getPersistedTrackingData: undefined,
        logError: undefined,
        logEvent: undefined,
        logMessage: undefined,
        logPurchase: undefined,
        setTrackingEnabled: undefined,
        getAttribution: undefined,
    },
    async: {},
    event: {},
});
